/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUrlOpenMethod, FxIdDomainSettingsUrlOpenMethodFromJSONTyped, FxIdDomainSettingsUrlOpenMethodToJSON, } from './FxIdDomainSettingsUrlOpenMethod';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUrlOpenMethod(json)) {
        return FxIdDomainSettingsUrlOpenMethodFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUrlOpenMethod(value)) {
        return FxIdDomainSettingsUrlOpenMethodToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethod.js.map